<script>
    export default {
        name: "DescriptionsItem",
        props: {
            schema: Object,
            data: Object,
        },
        functional: true,
        render(h, ctx) {
            const { schema, data } = ctx.props;
            const { label, span, labelClassName, contentClassName, labelStyle, contentStyle, render } = schema;
            const value = data[schema.name];
            return h(
                "el-descriptions-item",
                {
                    props: {
                        label, span, labelClassName, contentClassName, labelStyle, contentStyle
                    }
                },
                render && typeof render === "function"
                    ?
                    [render(h, { value, data })]
                    :
                    value
            );
        }
    };
</script>

<style scoped>

</style>
